import QuitaForm from './QuitaForm'
export {QuitaForm}
export default QuitaForm
